export default __webpack_public_path__ + "static/media/Note_2_img.fc83095b.jpg";